import Button from "common/Buttons/Button.tsx";
import { CSSProperties, useState } from "react";
import CreateBotModal from "common/Home/Header/CreateBotModal.tsx";
import PlusOutlined from "@ant-design/icons/PlusOutlined";
import useMedia from "utils/hooks/useMedia.ts";
import styled from "styled-components";
import { BOTTOM_NAVIGATOR } from "common/constants.ts";

interface CreateBotButtonProps {
  style?: CSSProperties;
}

const CreateBotButton = ({ style }: CreateBotButtonProps) => {
  const [openModal, setOpenModal] = useState(false);
  const isSmallScreen = useMedia([`(max-width: 1000px)`], [true], false);

  return (
    <>
      <StyledButton
        $type="secondary"
        $isSmallScreen={isSmallScreen}
        onClick={() => setOpenModal(true)}
        style={style}
      >
        <PlusIcon />
        {!isSmallScreen && "Create Bot"}
      </StyledButton>
      <CreateBotModal open={openModal} closeModal={() => setOpenModal(false)} />
    </>
  );
};

export default CreateBotButton;

const StyledButton = styled(Button)<{ $isSmallScreen: boolean }>`
  margin: 0 12px;
  height: 34px;
  ${(p) =>
    p.$isSmallScreen &&
    `
        width: 30px;
        height: 30px;
        padding: 0;
        margin-right: 6px;
    `};
  @media (max-width: ${BOTTOM_NAVIGATOR}) {
    width: 26px;
    height: 26px;
  }
`;
const PlusIcon = styled(PlusOutlined)`
  font-size: 12px;
`;
